module.exports = __webpack_public_path__ + "static/media/crimePredictions.9ec8fca6.png";